export default __webpack_public_path__ + "static/media/LogoSolicitudConsumo.cc6a19b5.svg";